<small class="debug"> {{ me }} </small>
<div [@loginState]="loginState" class="login-page" id="appLogin">
    <!-- Animated Background -->
    <div class="animated-background">
        <div class="gradient-orb orb-1"></div>
        <div class="gradient-orb orb-2"></div>
        <div class="gradient-orb orb-3"></div>
        <div class="floating-shapes">
            <div class="shape shape-1"></div>
            <div class="shape shape-2"></div>
            <div class="shape shape-3"></div>
            <div class="shape shape-4"></div>
            <div class="shape shape-5"></div>
        </div>
    </div>

    <!-- Theme and Language Selector -->
    <div *ngIf="!m_mode" class="langTheme site-mode">
        <app-local-diag [setLargeMode]="true"></app-local-diag>
        <app-theme-selector></app-theme-selector>
    </div>

    <!-- Main Login Container -->
    <div class="login-container">
        <form autocomplete="off" class="login-form" role="form">
            <div [ngSwitch]="m_currentViewMode">

                <!-- Init Mode -->
                <div *ngSwitchCase="m_viewMod.INIT" class="init-state">
                    <mat-icon class="spinning-icon">refresh</mat-icon>
                    <span>{{ 'general.initializing' | transloco }}</span>
                </div>

                <!-- Loading State -->
                <div *ngSwitchCase="m_viewMod.LOGIN_IN_PROGRESS" class="loading-state">
                    <app-loading [@fadeIn] [type]="'ai'" [size]="'100px'"></app-loading>
                    <div class="loading-text">
                        <span flashlightText>{{ 'general.loadingStudio' | transloco }}</span>
                    </div>
                </div>

                <!-- Login Form -->
                <div *ngSwitchCase="m_viewMod.LOGIN" class="login-card">
                    <!-- Logo Section -->
                    <div class="logo-section">
                        <app-logo [overrideDefaultClass]="stylesObj" *ngIf="m_mode !== 'CHECKOUT'"></app-logo>
                        <div class="brand-text" *ngIf="!isWhiteLabeled">
                            <span class="tagline">{{ 'account.freeSignage' | transloco }}</span>
                        </div>
                        <div class="mode-indicator" [ngSwitch]="m_mode">
                            <span *ngSwitchCase="'CREATE_ACCOUNT'" class="mode-badge create">
                                {{ 'general.createAccount2' | transloco }}
                            </span>
                            <span *ngSwitchCase="'CHECKOUT'" class="mode-badge checkout">
                                {{ 'general.readyForCheckout' | transloco }}
                            </span>
                            <ng-container *ngSwitchDefault>
                                <span class="mode-badge welcome" *ngIf="!isWhiteLabeled">
                                    {{ 'general.amazed' | transloco }}
                                </span>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Input Fields -->
                    <div class="input-section">
                        <small class="debug"> {{ me }} </small>

                        <!-- Username/Email Field -->
                        <div class="input-wrapper" [ngClass]="{'disabled': disabledLoginInputs}">
                            <mat-icon class="input-icon">person</mat-icon>
                            <mat-form-field appearance="outline" class="modern-input">
                                <mat-label *ngIf="m_mode === 'CREATE_ACCOUNT'">{{ 'account.email' | transloco }}</mat-label>
                                <mat-label *ngIf="m_mode !== 'CREATE_ACCOUNT'">{{ 'account.userEmail' | transloco }}</mat-label>
                                <input #userLogin *ngIf="m_mode === 'CREATE_ACCOUNT'"
                                       inputrestriction="login"
                                       (invalidCharacter)="messageInvalidCharChosen($event)"
                                       (blur)="checkUsername()"
                                       [disabled]="disabledLoginInputs"
                                       autocomplete="off"
                                       matInput
                                       (keyup.enter)="passFocus($event)"
                                       #userName
                                       spellcheck="false"
                                       type="text"
                                       name="m_user"
                                       [(ngModel)]="m_user"
                                       required>
                                <input #userLogin *ngIf="m_mode !== 'CREATE_ACCOUNT'"
                                       inputrestriction="login"
                                       (invalidCharacter)="messageInvalidCharChosen($event)"
                                       (blur)="checkUsername()"
                                       [disabled]="disabledLoginInputs"
                                       autocomplete="off"
                                       matInput
                                       (keyup.enter)="passFocus($event)"
                                       #userName
                                       spellcheck="false"
                                       type="text"
                                       name="m_user"
                                       [(ngModel)]="m_user"
                                       required>
                            </mat-form-field>
                        </div>

                        <!-- Password Field -->
                        <div class="input-wrapper" [ngClass]="{'disabled': disabledLoginInputs}">
                            <mat-icon class="input-icon">lock</mat-icon>
                            <mat-form-field appearance="outline" class="modern-input">
                                <mat-label>{{ 'account.password' | transloco }}</mat-label>
                                <input *ngIf="m_mode === 'CREATE_ACCOUNT'"
                                       [opts]="'password'"
                                       inputrestriction="password"
                                       (invalidCharacter)="messageInvalidCharChosen($event)"
                                       [disabled]="disabledLoginInputs"
                                       autocomplete="off"
                                       matInput
                                       (keyup.enter)="passFocusSecondPass()"
                                       #userPass
                                       type="password"
                                       [(ngModel)]="m_pass"
                                       name="m_pass"
                                       required>
                                <input *ngIf="m_mode !== 'CREATE_ACCOUNT'"
                                       [opts]="'password'"
                                       inputrestriction="password"
                                       (invalidCharacter)="messageInvalidCharChosen($event)"
                                       [disabled]="disabledLoginInputs"
                                       autocomplete="off"
                                       matInput
                                       (keyup.enter)="signInWithEmail()"
                                       #userPass
                                       type="password"
                                       [(ngModel)]="m_pass"
                                       name="m_pass"
                                       required>
                            </mat-form-field>
                        </div>

                        <!-- Repeat Password (Create Account Only) -->
                        <div class="input-wrapper" *ngIf="m_mode === 'CREATE_ACCOUNT'" [ngClass]="{'disabled': disabledLoginInputs}">
                            <mat-icon class="input-icon">lock_outline</mat-icon>
                            <mat-form-field appearance="outline" class="modern-input">
                                <mat-label>{{ 'account.repeatPass' | transloco }}</mat-label>
                                <input inputrestriction="password"
                                       [opts]="'password'"
                                       (invalidCharacter)="messageInvalidCharChosen($event)"
                                       [disabled]="disabledLoginInputs"
                                       autocomplete="off"
                                       matInput
                                       (keyup.enter)="createAccount($event)"
                                       #userPass2
                                       type="password"
                                       [(ngModel)]="m_passRepeat"
                                       name="m_passRepeat"
                                       required>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Social Login Options -->
                    <div class="social-section" *ngIf="(privateServer?.length > 10 || ldapServer?.length > 10) === false">
                        <div *ngIf="!isWhiteLabeled" class="social-buttons">
                            <button type="button"
                                    class="social-btn email-btn"
                                    [ngClass]="{'active': selectedLoginMode === 'loginWithEmail'}"
                                    matTooltipPosition="above"
                                    matTooltip="{{ 'account.loginNow' | transloco }}"
                                    (click)="onLoginWith('loginWithEmail', $event)">
                                <mat-icon>email</mat-icon>
                            </button>
                            <button type="button"
                                    class="social-btn google-btn"
                                    [ngClass]="{'active': selectedLoginMode === 'loginWithGL'}"
                                    matTooltipPosition="above"
                                    matTooltip="{{ 'account.loginWithGoogle' | transloco }}"
                                    (click)="onLoginWith('loginWithGL', $event)">
                                <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                                <fa-icon size="1x" [icon]="faGoogle"></fa-icon>
                            </button>
                            <button type="button"
                                    class="social-btn amazon-btn"
                                    [ngClass]="{'active': selectedLoginMode === 'loginWithAmazon'}"
                                    matTooltipPosition="above"
                                    matTooltip="{{ 'account.loginWithAmazon' | transloco }}"
                                    (click)="onLoginWith('loginWithAmazon', $event)">
                                <fa-icon [icon]="faAmazon"></fa-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="action-section" [ngSwitch]="selectedLoginMode">
                        <!-- Email Login -->
                        <div *ngSwitchCase="'loginWithEmail'" class="action-buttons">
                            <button *ngIf="m_mode === 'CREATE_ACCOUNT'"
                                    type="button"
                                    (click)="createAccount($event)"
                                    class="primary-btn"
                                    mat-flat-button>
                                <span>{{ 'account.continue' | transloco }}</span>
                                <mat-icon>arrow_forward</mat-icon>
                            </button>
                            <button *ngIf="m_mode !== 'CREATE_ACCOUNT'"
                                    type="button"
                                    (click)="signInWithEmail()"
                                    class="primary-btn"
                                    mat-flat-button>
                                <span>{{ 'account.loginNow' | transloco }}</span>
                                <mat-icon>login</mat-icon>
                            </button>
                        </div>

                        <!-- Guest Login -->
                        <div *ngSwitchCase="'continueAsGuest'" class="action-buttons">
                            <button type="button"
                                    (click)="signInGuest($event)"
                                    class="secondary-btn"
                                    mat-flat-button>
                                <span>{{ 'account.continueAsGuest' | transloco }}</span>
                                <mat-icon>person_outline</mat-icon>
                            </button>
                        </div>

                        <!-- Amazon Login -->
                        <div *ngSwitchCase="'loginWithAmazon'" class="action-buttons">
                            <button *ngIf="m_mode === 'CREATE_ACCOUNT'"
                                    class="amazon-action-btn"
                                    type="button"
                                    (click)="onLoginAmazonPopup($event)"
                                    mat-flat-button>
                                <span>{{ 'account.createWithAmazon' | transloco }}</span>
                                <fa-icon [icon]="faAmazon"></fa-icon>
                            </button>
                            <button *ngIf="m_mode !== 'CREATE_ACCOUNT'"
                                    class="amazon-action-btn"
                                    type="button"
                                    (click)="onLoginAmazonPopup($event)"
                                    mat-flat-button>
                                <span>{{ 'account.loginWithAmazon' | transloco }}</span>
                                <fa-icon [icon]="faAmazon"></fa-icon>
                            </button>
                        </div>

                        <!-- Google Login -->
                        <div *ngSwitchCase="'loginWithGL'" class="action-buttons google-action">
                            <div *ngIf="m_mode === 'CREATE_ACCOUNT'" class="google-login-wrapper" (click)="signInWithGoogle()">
                                <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                            </div>
                            <div *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="google-login-wrapper" (click)="signInWithGoogle()">
                                <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                            </div>
                        </div>

                        <!-- Facebook Login -->
                        <div *ngSwitchCase="'loginWithFB'" class="action-buttons">
                            <button *ngIf="m_mode === 'CREATE_ACCOUNT'"
                                    class="facebook-btn"
                                    type="button"
                                    (click)="signInWithFB()"
                                    mat-flat-button>
                                <span>{{ 'account.createWithFB' | transloco }}</span>
                                <fa-icon [icon]="faFacebook"></fa-icon>
                            </button>
                            <button *ngIf="m_mode !== 'CREATE_ACCOUNT'"
                                    class="facebook-btn"
                                    type="button"
                                    (click)="signInWithFB()"
                                    mat-flat-button>
                                <span>{{ 'account.loginWithFB' | transloco }}</span>
                                <fa-icon [icon]="faFacebook"></fa-icon>
                            </button>
                        </div>

                        <!-- Create Account Option -->
                        <div *ngIf="showCreateAccount && m_mode !== 'CREATE_ACCOUNT'" class="create-account-section">
                            <div class="divider">
                                <span>{{ 'account.or' | transloco }}</span>
                            </div>
                            <button type="button"
                                    (click)="createNewAccount($event)"
                                    class="secondary-btn create-btn"
                                    mat-stroked-button>
                                <span>{{ 'account.createNewAccount2' | transloco }}</span>
                                <mat-icon>person_add</mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Footer Links -->
                    <div class="footer-section">
                        <div *ngIf="!isWhiteLabeled; else showPassword" class="footer-links">
                            <button *ngIf="m_mode !== 'CREATE_ACCOUNT'"
                                    mat-icon-button
                                    class="footer-btn"
                                    matTooltip="{{ 'account.options' | transloco }}"
                                    (click)="onShowOptions('settings', $event)">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <button *ngIf="!isWhiteLabeled"
                                    mat-icon-button
                                    class="footer-btn"
                                    matTooltip="{{ 'account.downloads' | transloco }}"
                                    routerLink="/getstarted/downloads">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                            <button *ngIf="!isWhiteLabeled"
                                    mat-icon-button
                                    class="footer-btn"
                                    matTooltip="{{ 'account.cart' | transloco }}"
                                    routerLink="/shopping-cart/list">
                                <mat-icon>shopping_cart</mat-icon>
                            </button>
                            <button *ngIf="!isWhiteLabeled"
                                    mat-icon-button
                                    class="footer-btn"
                                    matTooltip="{{ 'account.products' | transloco }}"
                                    routerLink="/shopping-cart/products">
                                <mat-icon>local_offer</mat-icon>
                            </button>
                            <button mat-icon-button
                                    class="footer-btn"
                                    matTooltip="{{ 'account.homePage' | transloco }}"
                                    (click)="onShowOptions('home', $event)">
                                <mat-icon>home</mat-icon>
                            </button>
                            <button *ngIf="!isWhiteLabeled"
                                    mat-icon-button
                                    class="footer-btn"
                                    matTooltip="{{ 'account.help' | transloco }}"
                                    (click)="navigateToParam($event, '/shopping-cart/helpdesk?back=true')">
                                <mat-icon>help_outline</mat-icon>
                            </button>
                        </div>
                        <ng-template #showPassword>
                            <a *ngIf="showCreateAccount"
                               class="forgot-link"
                               (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)"
                               href="#">
                                {{ 'account.forgotPassword' | transloco }}
                            </a>
                        </ng-template>

                        <!-- Forgot Password (White Labeled) -->
                        @if (isWhiteLabeled && !showCreateAccount) {
                            <div class="forgot-password-section">
                                <a class="forgot-link"
                                   (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)"
                                   href="#">
                                    <mat-icon>report</mat-icon>
                                    <span>{{ 'account.forgotPassword' | transloco }}</span>
                                </a>
                            </div>
                        }

                        <!-- Private Server Indicator -->
                        <div class="server-indicators">
                            <span class="server-badge" *ngIf="privateServer && privateServer.length > 10">
                                <mat-icon>verified_user</mat-icon>
                                {{ 'account.privateEnabled' | transloco }}
                            </span>
                            <span class="server-badge" *ngIf="ldapServer && ldapServer.length > 10">
                                <mat-icon>verified_user</mat-icon>
                                {{ 'account.ldapEnabled' | transloco }}
                            </span>
                        </div>

                        <!-- Settings Panel -->
                        <div class="settings-panel" *ngIf="selectedOptions === 'settings'">
                            <div class="settings-content">
                                <label class="checkbox-wrapper">
                                    <input #rememberMe
                                           type="checkbox"
                                           [checked]="m_rememberMe"
                                           (change)="m_rememberMe = rememberMe.checked"/>
                                    <span class="checkmark"></span>
                                    <span class="checkbox-label">{{ 'account.rememberMe' | transloco }}</span>
                                </label>
                                <div class="settings-links">
                                    <a *ngIf="!isWhiteLabeled"
                                       class="settings-link"
                                       (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)"
                                       href="#">
                                        <mat-icon>report</mat-icon>
                                        <span>{{ 'account.forgotPassword' | transloco }}</span>
                                    </a>
                                    <a class="settings-link"
                                       (click)="$event.preventDefault(); setViewMode(m_viewMod.CHANGE_PASSWORD)"
                                       href="#">
                                        <mat-icon>vpn_key</mat-icon>
                                        <span>{{ 'account.changePassword' | transloco }}</span>
                                    </a>
                                    <a class="settings-link"
                                       (click)="$event.preventDefault(); setupWithPrivates()"
                                       href="#">
                                        <mat-icon>build</mat-icon>
                                        <span>{{ 'account.advancedLogin' | transloco }}</span>
                                    </a>
                                    <div class="version-info">
                                        {{ 'account.version' | transloco }}: {{ appVersion }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Change Password View -->
                <div *ngSwitchCase="m_viewMod.CHANGE_PASSWORD" class="sub-view">
                    <app-change-password></app-change-password>
                </div>

                <!-- Forgot Password View -->
                <div *ngSwitchCase="m_viewMod.FORGOT_PASSWORD" class="sub-view">
                    <app-forgot-password></app-forgot-password>
                </div>

                <!-- Change Business Name View -->
                <div *ngSwitchCase="m_viewMod.CHANGE_BUSINESS_NAME" class="sub-view">
                    <app-business-rename></app-business-rename>
                </div>

                <!-- Error State -->
                <div *ngSwitchDefault class="error-state">
                    <mat-icon class="error-icon">error_outline</mat-icon>
                    <h2>{{ 'general.somethingWentWrong' | transloco }}</h2>
                    <p>mode: {{ m_currentViewMode }}</p>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Private Server Modal -->
<ng-template let-modal #privatesModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">build</mat-icon>
        <span class="section-title">{{ 'placeholder.serverConnection' | transloco }}</span>
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="privates-dialog-content">
        <div class="server-options">
            <div class="server-option">
                <mat-checkbox [checked]="privateServer.length > 0"
                              (change)="onPrivatesCheckboxChanged('privateServer', $event.checked)">
                    <mat-icon>storage</mat-icon>
                    <span>{{ 'account.privateSignage2' | transloco }}</span>
                </mat-checkbox>
            </div>
            <div class="server-option">
                <mat-checkbox [checked]="ldapServer.length > 0"
                              (change)="onPrivatesCheckboxChanged('ldapServer', $event.checked)">
                    <mat-icon>storage</mat-icon>
                    <span>LDAP {{ 'account.server' | transloco }}</span>
                </mat-checkbox>
            </div>
        </div>
        <div class="server-inputs">
            <mat-form-field appearance="outline" class="server-input" [ngClass]="{'disabled': privateServer.length === 0}">
                <mat-label>{{ 'placeholder.privateServerDomain' | transloco }}</mat-label>
                <input matInput
                       placeholder="https://master.example.com"
                       (change)="onUpdatePrivatesStore('privateServer', $event.target['value'])"
                       [value]="privateServer"
                       type="text"
                       autocomplete="off"
                       [disabled]="privateServer.length === 0">
            </mat-form-field>
            <mat-form-field appearance="outline" class="server-input" [ngClass]="{'disabled': ldapServer.length === 0}">
                <mat-label>{{ 'placeholder.privateLdapDomain' | transloco }}</mat-label>
                <input matInput
                       placeholder="server-address:domain-controller"
                       (change)="onUpdatePrivatesStore('ldapServer', $event.target['value'])"
                       [value]="ldapServer"
                       type="text"
                       autocomplete="off"
                       [disabled]="ldapServer.length === 0">
            </mat-form-field>
        </div>
    </div>
</ng-template>
